// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Preloader_Loader__1OSik","load2":"Preloader_load2__3kxyz","Inverse":"Preloader_Inverse__3arXP","Dark":"Preloader_Dark__-8rzp"};